import React from 'react';
import { PhoneCall, FileText, RefreshCw, Calendar } from 'lucide-react';
import { EngagementEntry } from '../data/borrowers';
interface EngagementTimelineProps {
  entries: EngagementEntry[];
}
export function EngagementTimeline({
  entries
}: EngagementTimelineProps) {
  const getIcon = (type: string) => {
    switch (type) {
      case 'call':
        return <PhoneCall className="w-4 h-4" data-id="element-64" />;
      case 'note':
        return <FileText className="w-4 h-4" data-id="element-65" />;
      case 'status':
        return <RefreshCw className="w-4 h-4" data-id="element-66" />;
      case 'followup':
        return <Calendar className="w-4 h-4" data-id="element-67" />;
      default:
        return <FileText className="w-4 h-4" data-id="element-68" />;
    }
  };
  const getIconColor = (type: string) => {
    switch (type) {
      case 'call':
        return 'bg-blue-100 text-blue-600';
      case 'note':
        return 'bg-slate-100 text-slate-600';
      case 'status':
        return 'bg-purple-100 text-purple-600';
      case 'followup':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-slate-100 text-slate-600';
    }
  };
  return <div className="space-y-4" data-id="element-69">
      {entries.map((entry, index) => <div key={entry.id} className="flex gap-3" data-id="element-70">
          <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${getIconColor(entry.type)}`} data-id="element-71">
            {getIcon(entry.type)}
          </div>
          <div className="flex-1 min-w-0" data-id="element-72">
            <div className="flex items-start justify-between gap-2" data-id="element-73">
              <p className="text-sm font-medium text-slate-900" data-id="element-74">
                {entry.title}
              </p>
              <span className="text-xs text-slate-500 whitespace-nowrap" data-id="element-75">
                {entry.timestamp}
              </span>
            </div>
            {entry.body && <p className="text-sm text-slate-600 mt-1" data-id="element-76">{entry.body}</p>}
          </div>
        </div>)}
    </div>;
}